module.exports = __webpack_public_path__ + "img/d201202-2.60349cc1.jpg";